import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import EmployeesList from './EmployeesList'

export default function Employees() {
	return (
		<React.Fragment>
			<Switch>
				<Route path="/employees" component={EmployeesList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}